'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = onDelete;

var _constants = require('./constants');

var _utils = require('./utils');

/**
 * Sticky Delete Link logic
 *
 * @param {Event} event
 * @param {Editor} editor
 * @param {function} next
 * @param {Objects} opts
 * @return {Any}
 */

function onDelete(event, editor, next, opts) {
  var _editor$value = editor.value,
      document = _editor$value.document,
      selection = _editor$value.selection,
      focusInline = _editor$value.focusInline,
      focusText = _editor$value.focusText;
  var canBeEmpty = opts.canBeEmpty,
      stickOnDelete = opts.stickOnDelete;

  if (selection.isExpanded) return next();

  // Logic for deleting "into" a sticky inline
  var isAtEndOfCurrentTextNode = !focusInline && selection.focus.offset === focusText.text.length;

  if (isAtEndOfCurrentTextNode && stickOnDelete) {
    var upcomingNode = document.getNextSibling(selection.focus.path);
    if ((0, _utils.isInlineBanned)(editor, upcomingNode, opts)) return next();

    event.preventDefault();
    return editor.moveToStartOfNode(upcomingNode).deleteForward();
  }

  // Logic for deleting inside the sticky inline
  if (!focusInline || !canBeEmpty) return next();
  if (focusInline.text.length === 1 && focusInline.text === _constants.ZERO_WIDTH_SPACE) return next();

  if (focusInline.text.length !== 1) return next();
  event.preventDefault();
  return editor.insertText(_constants.ZERO_WIDTH_SPACE).moveBackward(1).deleteBackward().moveForward(1);
}